type WindowWithElectronClipboard = Window & {
  electronAPI?: {
    clipboard?: {
      writeText?: (
        text: string,
      ) => Promise<{ success: boolean; error?: string }>;
    };
  };
};

export async function writeTextToClipboard(text: string): Promise<void> {
  if (typeof window !== 'undefined') {
    const electronClipboard = (window as WindowWithElectronClipboard)
      .electronAPI?.clipboard;
    if (electronClipboard?.writeText) {
      try {
        const result = await electronClipboard.writeText(text);
        if (result?.success) {
          return;
        }
        console.warn(
          'Electron clipboard write reported failure, falling back to navigator.clipboard',
          result?.error,
        );
      } catch (error) {
        console.warn(
          'Electron clipboard write threw, falling back to navigator.clipboard',
          error,
        );
      }
    }
  }

  try {
    await navigator.clipboard.writeText(text);
  } catch (error) {
    console.error('Failed to copy to clipboard:', error);
  }
}
